import { HttpClient } from '@angular/common/http'
import { TranslateLoader, TranslationObject } from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

// tslint:disable: max-line-length
/**
 * Custom translate loader to map \n line break string sequences
 * received from server to actual line break characters.
 * Forked from the original implementation at
 * https://github.com/ngx-translate/http-loader/blob/master/projects/ngx-translate/http-loader/src/lib/http-loader.ts
 */
// tslint:enable: max-line-length
export class AppTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public prefix: string = '/assets/i18n/',
    public suffix: string = '.json',
  ) {}

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string): Observable<TranslationObject> {
    // Used to change MessageFormat-style interpolation tags into Angular-style interpolation tags
    const interpolationFormatRegex = /{[^\s]+}/gm

    return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(
      map((serverTranslations: Record<string, string>) => {
        const parsedTranslations: Record<string, string> = {}

        // We have to parse the backend translations to prevent some issues
        Object.keys(serverTranslations).forEach(key => {
          if ({}.hasOwnProperty.call(serverTranslations, key)) {
            // Change newline escape characters into actual newlines
            parsedTranslations[key] = (serverTranslations[key] as string).split('\\n').join('\n')

            // Change MessageFormat-style interpolation tags "{0}" into Angular-style interpolation tags "{{0}}
            parsedTranslations[key] = parsedTranslations[key].replace(interpolationFormatRegex, '{$&}')
          }
        })

        return parsedTranslations
      }),
    )
  }
}

// AOT compilation support
export function HttpLoaderFactory(http: HttpClient): AppTranslateHttpLoader {
  return new AppTranslateHttpLoader(http, './Api/Core/Translation/', '')
}
